import React from 'react';
import CustomCircularProgress from '../common/CustomCircularProgress';
import LowboyEmployeeCard from './LowboyEmployeeCard';
import AssignmentActionBar from './AssignmentActionBar';

export default class LowboyAssignmentPane extends React.Component {
    renderAssignments() {
        const { lowboyAssignments } = this.props;

        if (!lowboyAssignments || lowboyAssignments.length == 0) {
            return <>No assignments found.</>;
        }

        return <>{lowboyAssignments.length} lowboy assignments.</>;
    }

    renderEmployees() {
        const { lowboyEmployees } = this.props;

        if (!lowboyEmployees || lowboyEmployees.length == 0) {
            return <>No employees found.</>;
        }

        return <>{lowboyEmployees.length} lowboy employees.</>;
    }

    render() {
        const { assignmentsLoading, lowboyEmployees } = this.props;

        return (
            <div className="assignment-pane">
                <legend className="d-flex flex-row align-items-center">
                    ASSIGNMENTS
                </legend>

                <AssignmentActionBar {...this.props} />

                <div className="p-1 employee-card-container">
                    {assignmentsLoading && <CustomCircularProgress />}

                    {!assignmentsLoading &&
                        lowboyEmployees.map((le, i) => (
                            <LowboyEmployeeCard
                                key={le.id}
                                lowboyEmployee={le}
                                index={i}
                                {...this.props}
                            />
                        ))}
                </div>
            </div>
        );
    }
}
